import { motion } from "framer-motion";
import { EASE_EDITORIAL } from "../components/Reveal";

const ROLES = ["Creative Director", "Stylist", "Storyteller", "Head Chef, We Cook Art"];

const Hero = () => {
  return (
    <section data-testid="hero-section" className="relative h-[100svh] w-full overflow-hidden bg-noir">
      {/* Cinematic portrait */}
      <motion.img
        src="/images/gold-02.jpg"
        alt="A frame from We Cook Art — Woman Who Ate Gold"
        initial={{ scale: 1.12, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 2.4, ease: EASE_EDITORIAL }}
        className="absolute inset-0 h-full w-full object-cover object-[center_22%]"
      />
      {/* Tonal wash for legibility */}
      <div className="absolute inset-0 bg-gradient-to-t from-noir/85 via-noir/20 to-noir/40" />
      <div className="absolute inset-0 bg-gradient-to-r from-noir/40 to-transparent" />

      {/* Overline */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1, duration: 1.4 }}
        className="absolute left-6 top-28 z-10 sm:left-10"
      >
        <span className="text-[0.7rem] uppercase tracking-[0.32em] text-noir-text/70">
          A Visual Archive
        </span>
      </motion.div>

      {/* Title block */}
      <div className="absolute bottom-0 left-0 z-10 w-full px-6 pb-16 sm:px-10 sm:pb-20">
        <div className="mx-auto max-w-[1600px]">
          <motion.h1
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.5, duration: 1.6, ease: EASE_EDITORIAL }}
            className="font-serif text-[18vw] font-light leading-[0.82] tracking-tight text-ivory sm:text-[13vw] lg:text-[11rem]"
          >
            Pavitra
            <br />
            <span className="italic text-gold">Mishra</span>
          </motion.h1>

          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 1.2, duration: 1.4 }}
            className="mt-7 flex flex-wrap items-center gap-x-4 gap-y-2"
          >
            {ROLES.map((r, i) => (
              <span key={r} className="flex items-center gap-4">
                {i > 0 && <span className="h-1 w-1 rounded-full bg-gold/80" />}
                <span className="text-[0.7rem] uppercase tracking-[0.24em] text-noir-text/85 sm:text-xs">
                  {r}
                </span>
              </span>
            ))}
          </motion.div>
        </div>
      </div>

      {/* Scroll cue */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.8, duration: 1.4 }}
        className="absolute bottom-8 right-6 z-10 hidden items-center gap-3 sm:right-10 md:flex"
      >
        <span className="text-[0.65rem] uppercase tracking-[0.24em] text-noir-text/60">Scroll</span>
        <motion.span
          animate={{ y: [0, 8, 0] }}
          transition={{ duration: 2.2, repeat: Infinity, ease: "easeInOut" }}
          className="block h-8 w-px bg-noir-text/50"
        />
      </motion.div>
    </section>
  );
};

export default Hero;
